import { Component } from '@angular/core';
import { MatCalendar } from '@angular/material/datepicker';
import { DateAdapter } from '@angular/material/core';

@Component({
    selector: 'custom-calendar-header',
    template: `
    <div class="custom-calendar-header">
        <button mat-button class="mat-calendar-period-button">
            {{ monthAndYear }}
        </button>
        <div class="prev-next-btn">
            <button mat-button class="mat-calendar-nav-button" (click)="goToPrevMonth()">
                <img src="../../../../../../assets/icons/left-arrow.svg" alt="prev" class="prev-img">
            </button>
            <button mat-button class="mat-calendar-nav-button" (click)="goToNextMonth()">
                <img src="../../../../../../assets/icons/right-arrow.svg" alt="next" class="next-img"> 
            </button>
        </div>
    </div>
  `,
    styles: [
        `
      .custom-calendar-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px 0;
      }
      .prev-next-btn {
        display: flex;
      }
      .mat-calendar-nav-button {
        background: transparent;
        border: none;
        display: flex;
        cursor: pointer;
        padding: 0 2px;
      }
      .mat-calendar-period-button{
        border: none;
        background:transparent;
        font-style: normal;
        font-weight: 500;
        font-size: 21px;
        line-height: 25px;
        color: #1E2D3B;
        font-family: "NeurialGrotesk-medium", sans-serif;
      }
    `,
    ],
})
export class CustomCalendarHeader {
    constructor(
        private calendar: MatCalendar<Date>
    ) { }

    get monthAndYear(): string {
        const date = this.calendar.activeDate;
        const formatter = new Intl.DateTimeFormat('fr-FR', { year: 'numeric', month: 'long' });
        const formattedDate = formatter.format(date);
        return formattedDate.charAt(0).toUpperCase() + formattedDate.slice(1);;
    }



    goToPrevMonth(): void {
        const currentDate = this.calendar.activeDate;
        const previousMonth = new Date(currentDate);
        previousMonth.setMonth(currentDate.getMonth() - 1);
        this.calendar.activeDate = previousMonth;
    }

    goToNextMonth(): void {
        const currentDate = this.calendar.activeDate;
        const nextMonth = new Date(currentDate);
        nextMonth.setMonth(currentDate.getMonth() + 1);
        this.calendar.activeDate = nextMonth;
    }
}
